<template>

  <div id="mada-royaumes" class="madagascar">
    <div class="page-container">

      <transition
          v-bind:css="false"
          v-on:enter="enter"
          v-on:leave="leave"
          v-on:before-enter="beforeEnter"
      >
        <router-view :key="$route.fullPath"></router-view>
      </transition>

    </div>
    <transition name="fade">
      <a v-if="!isHome" class="home-btn" href="#" @click.prevent="$router.push('/')">
        <icon-base icon-color="#fff" size="3vw">
          <icon-home/>
        </icon-base>
      </a>
    </transition>


    <div class="test" v-if="displayTest">
      <screen-sizes/>
      | lang {{ $store.state.language }} |
      <router-link to="/">Home</router-link>
      <br>
    </div>
  </div>
</template>

<script>
import {gsap, Power3} from "gsap";
import ScreenSizes from "shared-src/debug/ScreenSizes";

import IconBase from "shared-src/icons/IconBase";
import IconHome from "shared-src/icons/IconHome";
import TranslatedObject from "shared-src/data/TranslatedObject";

export default {
  name: "MadaTemp",
  components: {
    ScreenSizes,
    IconBase,
    IconHome,
  },
  data() {
    return {
      isHome: true,
      "transitionIn": "fadeIn",
      "transitionOut": "fadeOut",
      transiParams: {
        duration: 0.5
      },
      displayTest: true,
      loadAsync: false

    }
  },
  created() {
    let me = this;
    this.$root.$on("changeLanguage", function (langCode) {
      this.$store.state.language = langCode;
      this.$router.push(`/${langCode}/temp`);
    });
    setTimeout(function () {
      me.displayTest = false;
    },1000 * 10)
    this.refreshAccordingRoute();
  },
  methods: {
    refreshAccordingRoute() {
      let route = this.$router.currentRoute;
      this.isHome = route.name === "home";
      if (route.name === "home") {
        this.$store.state.language = null;
      } else {
        this.$store.state.language = route.params.langCode;
        TranslatedObject.currentLanguage = route.params.langCode;
      }

    },
    beforeEnter: function (el) {
      console.log("beforeEnter", this.$router.currentRoute, el);
    },
    enter: function (el, done) {
      let tl = gsap.timeline({onComplete: done});
      let moveBy = window.innerWidth;

      switch (this.transitionIn) {
        case "cash":
          break;
        case "fadeIn":
          tl.to(el, {
                opacity: 0,
                duration: 0
              }
          );
          tl.to(el, {
                opacity: 1,
                duration: 1
              }
          );
          break;
        case "slideInLeft":
          tl.to(el, {x: -moveBy, duration: 0});
          tl.to(el, {
            x: 0,
            duration: this.transiParams.duration,
            ease: Power3.easeInOut
          });
          break;
        case "slideInRight":
          tl.to(el, {x: moveBy, duration: 0});
          tl.to(el, {
            x: 0,
            duration: this.transiParams.duration,
            ease: Power3.easeInOut
          });
          break;
      }
    },
    leave: function (el, done) {
      let moveBy = screen.width * 1;
      console.log("leave", el, done);
      let tl = gsap.timeline({onComplete: done});
      switch (this.transitionOut) {
        case "cash":
          break;
        case "fadeOut":
          tl.to(el, {
            opacity: 0,
            duration: this.transiParams.duration / 2
          });
          break;
        case "slideOutLeft":
          tl.to(el, {
            x: -moveBy,
            duration: this.transiParams.duration,
            ease: Power3.easeInOut
          });
          break;
        case "slideOutRight":
          tl.to(el, {
            x: moveBy,
            duration: this.transiParams.duration,
            ease: Power3.easeInOut
          });
          break;
      }
    }
  },
  watch: {
    '$route'(to, from) {
      console.log("transi watch", from.fullPath, to.fullPath);
      this.refreshAccordingRoute();
      switch (true) {
        case to.name === "home":
        case from.name === "home":
        case to.name === "map":
        case from.name === "map":

          this.transitionIn = "fadeIn";
          this.transitionOut = "fadeOut";
          //this.transitionIn="cash";
          //this.transitionOut="cash";
          break;

        case to.name === "foko":
          this.transitionOut = "slideOutLeft";
          this.transitionIn = "slideInRight";
          break;

        case to.name === "royaume":
          this.transitionOut = "slideOutRight";
          this.transitionIn = "slideInLeft";
          break;

        default:
          this.transitionIn = "fadeIn";
          this.transitionOut = "fadeOut";
          break;

      }
    }
  }
}
</script>

<style lang="less">

//reset----------------------
html, body, * {
  box-sizing: border-box;
}

@import "../typographie.less";
@import "../../../shared-src/scroll-skin.less";
@import "../../node_modules/@material/elevation/dist/mdc.elevation.min.css";

.test {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
  color: white;
  font-size: 10px;
  font-family: monospace;
  padding: 8px;

  a {
    color: white;
  }
}

//global styles---------------
.madagascar {
  background-color: #333;
  background-size: cover;
  background-image: url("../assets/textures/bg-texture.jpg");
  color: #fff;
  overflow: hidden;

  .home-btn {
    border: 1px solid #fff;
    border-radius: 100%;
    height: 3vw;
    width: 3vw;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 1.5vw;
    left: 2.5vw;
  }
}

#mada-royaumes {
  //layout variables-------------

  --page-width: 100vw;
  --page-height: 100vh;

  width: 100%;
  height: 100%;
  position: absolute;
}

.page-container {
  position: absolute;
  width: 100%;
  height: 100%;

  > * {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>